var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"app--footer px-3",attrs:{"inset":"","app":""}},[_c('v-spacer'),_c('span',{staticClass:"caption"},[_vm._v("Shelter Group © "+_vm._s(new Date().getFullYear()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }